// eslint-disable-next-line import/extensions
import CustodianService from '@advisor/rwSdk/CustodianService.ts';
import {transformApiResponse} from '@advisor/util/bankLinks/formatBankLinkAccount';

const mergeResponses = async (clUserId) => {
  const alldBankAccounts = await CustodianService.getAllBankAccountsForClUser({
    clUserId,
  });
  const identityRequests = await CustodianService.getBankAccountIdentityRequestsForClUser({
    clUserId,
  });
  const microDepositRequests = await CustodianService.getMicroDeposit({
    clUserId,
  });
  const linkedBankAccounts = await CustodianService.getLinkedBankAccountsForClUser({clUserId});

  const bankAccounts = transformApiResponse(alldBankAccounts, linkedBankAccounts, identityRequests, microDepositRequests);

  return {
    ...bankAccounts,
  };
};

export const linkedBankAccounts = (clUserId) => mergeResponses(clUserId);

export default {
  linkedBankAccounts,
};
